export default {"src":"/_next/static/media/tutorial-introduce.f6ac633d.svg","height":72,"width":105,"blurWidth":0,"blurHeight":0};